module.exports = "/static/assets/3c20092903063da1188ed242f2ce318c.gif";